import React, { ReactElement } from 'react';
import NotFoundComponent from '../../components/404';

const NotFound: React.FC = (): ReactElement => {
  return <NotFoundComponent />;
};

export default NotFound;